module.exports = __webpack_public_path__ + "static/media/vrcoin.8330fffd.png";